module["exports"] = [
  "Brasil"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/pt_BR/address/default_country.js
// module id = 1590
// module chunks = 0